import { Keys } from './Keys';

export module KeydownOutsideDetector {

  export function attach(
    element: JQuery,
    getIdFn: (element: JQuery) => string,
    downOutsideFn: (keydownEvent: JQueryEventObject) => any,
    keysToListenTo: Keys[]
  ): () => void {
    const doc = $(document);
    const eventNamespace = '.KeydownOutsideDetector' + getIdFn(element);
    const events = 'keydown' + eventNamespace;

    doc.on(events, (downEvent: JQueryEventObject) => {
      const key = (event as KeyboardEvent).which;
      if (keysToListenTo.includes(key)) {
        const target = $(downEvent.target);

        if (target.closest(element).length === 0) {
          downOutsideFn(downEvent);
        }
      }
    });

    return () => doc.off(eventNamespace);
  }

}
